// components/Dashboard/AdHocPlaylist.jsx

import React from 'react';

function AdHocPlaylist({
  adHocPlaylist,
  selectedPlaylistItem,
  setSelectedPlaylistItem,
  handleMoveUp,
  handleMoveDown,
  handleRemoveSelected,
  handleClear,
}) {
  const getBadgeClass = (type) => {
    if (type === 's3_video') return 'badge-video';
    if (type === 's3_image') return 'badge-image';
    if (type === 's3_audio') return 'badge-audio';
    return 'badge-youtube';
  };

  const getBadgeLabel = (type) => {
    if (type === 's3_video') return 'Saved Video';
    if (type === 's3_image') return 'Saved Image';
    if (type === 's3_audio') return 'Saved Audio';
    return 'YouTube';
  };

  const renderThumbnail = (item) => {
    const thumbSrc = item.preview_api_url || item.thumbnail_url || item.thumbnail_api_url || '';
    if (thumbSrc) {
      return <img src={thumbSrc} alt={item.title} className="playlist-thumb" />;
    }
    const glyph = item.content_type === 's3_audio' ? '🎵' : item.title ? item.title.charAt(0) : 'A';
    return (
      <div className="saved-asset-fallback-thumb playlist-thumb-fallback">
        {glyph}
      </div>
    );
  };

  return (
    <div className="ad-hoc-playlist-section">
      <h3>Find and Add Media</h3>
      {adHocPlaylist.length > 0 ? (
        <div className="playlist-items">
          {adHocPlaylist.map((video, index) => (
            <div
              key={index}
              className={`playlist-item ${selectedPlaylistItem === index ? 'selected' : ''}`}
              onClick={() => setSelectedPlaylistItem(index)}
            >
              <div className="ad-hoc-thumb">
                {renderThumbnail(video)}
                <span className={`asset-type-badge ${getBadgeClass(video.content_type)}`}>
                  {getBadgeLabel(video.content_type)}
                </span>
              </div>
              <div className="playlist-item-details">
                <div className="playlist-item-top-row">
                  <span className="playlist-item-title">{video.title}</span>
                </div>
                {video.content_type === 's3_image' && (
                  <span className="playlist-item-duration-tag">
                    Duration: {video.duration || 30}s
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="ad-hoc-empty-message">Playlist Empty - Fallback Playlist is in use.</p>
      )}
      <div className="device-controls ad-hoc-controls">
        <button onClick={handleMoveUp} disabled={selectedPlaylistItem === null} className="ad-hoc-btn move">
          Move Up
        </button>
        <button onClick={handleMoveDown} disabled={selectedPlaylistItem === null} className="ad-hoc-btn move">
          Move Down
        </button>
        <button onClick={handleRemoveSelected} disabled={selectedPlaylistItem === null} className="ad-hoc-btn remove">
          Remove Selected
        </button>
        <button onClick={handleClear} disabled={adHocPlaylist.length === 0} className="ad-hoc-btn clear">
          Clear
        </button>
      </div>
    </div>
  );
}

export default AdHocPlaylist;
